import { connect } from 'react-redux';
import View from './view';
import { currentClientIdSelector } from '../../../CommonSelectors/CommonAreaSelector';
import * as selector from './selector';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientIdSelector(state),
  assumptionsValuesList: selector.insuranceAssumptionsValuesSelector(state, ownProps),
  assumptionsLabelMap: selector.insuranceAssumptionsLabelPopulated(state, ownProps),
});

export default connect(
  mapStateToProps,
  {},
)(View);
